var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupItemsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333984 0.333374V5.66671H1.66732V24.3334H0.333984V29.6667H5.66732V28.3334H24.334V29.6667H29.6673V24.3334H28.334V5.66671H29.6673V0.333374H24.334V1.66671H5.66732V0.333374H0.333984ZM5.66732 4.33337H24.334V5.66671H25.6673V24.3334H24.334V25.6667H5.66732V24.3334H4.33398V5.66671H5.66732V4.33337ZM7.00065 7.00004V17.6667H11.0007V23H23.0007V11H17.6673V7.00004H7.00065ZM9.66732 9.66671H15.0007V15H9.66732V9.66671ZM17.6673 13.6667H20.334V20.3334H13.6673V17.6667H17.6673",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupItemsIcon);
export default __webpack_public_path__ + "static/media/group-items-icon.2dc4cbe39a30f25e6a1910eed0e3ea36.svg";
export { ForwardRef as ReactComponent };